import React from "react";
import { Link, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Activate() {
  return <Navigate to="/login" replace />;
}

export function ActivateNotice() {
  return (
    <div className="min-h-screen bg-[#F7F7F8] flex items-center justify-center p-6">
      <div className="max-w-md bg-white border border-[#E4E4E7] rounded-2xl p-8">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#71717A] mb-6">
          <ArrowLeft className="w-4 h-4" /> Home
        </Link>
        <h1 className="font-heading text-2xl font-semibold mb-2">Attivazione gestita da VELTA</h1>
        <p className="text-sm text-[#52525B] mb-6">
          I tenant vengono attivati dal SuperAdmin. Accedi con le credenziali ricevute dal titolare o richiedi un preventivo.
        </p>
        <div className="flex gap-3">
          <Link to="/login" className="h-11 px-5 bg-[#B73C27] text-white rounded-xl text-sm font-medium inline-flex items-center">Accedi</Link>
          <Link to="/preventivo" className="h-11 px-5 border border-[#E4E4E7] rounded-xl text-sm font-medium inline-flex items-center">Preventivo</Link>
        </div>
      </div>
    </div>
  );
}
